import TableCellSpace from "ds/components/Table/Row/CellSpace";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import { IntegrationsAwsUsedByTableCellProps } from "./types";

const IntegrationsAwsUsedByTableSpaceCell = ({
  item: stack,
  ...cellProps
}: IntegrationsAwsUsedByTableCellProps) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellSpace href={`/spaces/${stack.spaceDetails.id}`}>
        {stack.spaceDetails.name}
      </TableCellSpace>
    </TableSimpleCell>
  );
};

export default IntegrationsAwsUsedByTableSpaceCell;
